// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dispachModeldiv {
  background-color: var(--white);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-shadow: 0 0 6px var(--boxshadow);
  padding: 60px;
  min-width: 700px;
  max-height: calc(100vh - 100px);
  overflow: auto;
  max-width: calc(100vw - 100px);
  z-index: 1;
}

.dispachprintBtn {
  background-color: var(--theme1);
  color: var(--white);
  border: 0;
  padding: 5px;
  height: 40px;
  width: 120px;
  border-radius: 10px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/Screen/Admin/DispachOrder/dispachOrder.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".dispachModeldiv {\n  background-color: var(--white);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-shadow: 0 0 6px var(--boxshadow);\n  padding: 60px;\n  min-width: 700px;\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  max-width: calc(100vw - 100px);\n  z-index: 1;\n}\n\n.dispachprintBtn {\n  background-color: var(--theme1);\n  color: var(--white);\n  border: 0;\n  padding: 5px;\n  height: 40px;\n  width: 120px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
